import { QIcon_chevron_left } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_ai_tutor } from '../../../modules/i18n/strings/auto/wording'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

import useTranslation from '../../../modules/i18n/useTranslation'
const AITutorReportBody = dynamic(() => import('../../new-portal/ai-tutor/AITutorReport'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const AITutorReportHeader = () => {
  const { t } = useTranslation()
  const { useAITutorFlow } = useAITutorStack()
  const { pop } = useAITutorFlow()
  const routerMoveListPage = () => {
    pop()
  }

  return (
    <header className="fixed z-10 bg-white flex w-full gap-[16px] h-[52px] items-center justify-between">
      <QIcon_chevron_left width={24} height={24} onClick={routerMoveListPage} />
      <div className="flex flex-row gap-[16px] items-center justify-center">
        <div className="text-gray-800 text-left Body1-16Bd">{t(n_ai_tutor.error_report.title)}</div>
      </div>
      <div></div>
    </header>
  )
}

interface AITutorReportActivityType {
  params: {
    lessonId: any
    activityId: any
  }
}

const AITutorReportActivity: ActivityComponentType = ({ params }: AITutorReportActivityType) => {
  const { query } = useAppRouter()
  const lessonId = params?.lessonId || query?.lessonId
  const activity = params?.activityId || query?.activityId

  return (
    <WebviewStackContainer height="52px" title={<AITutorReportHeader />} border={false}>
      <AITutorReportBody lessonId={lessonId} activity={activity} />
    </WebviewStackContainer>
  )
}

export default AITutorReportActivity
